export default function coordinatesToTiles(longitude, latitude, zoom) {

    if (longitude<-180) longitude = longitude +360;
    if (longitude>180) longitude = longitude -360;
    
    const tileX = Math.floor((longitude+180) / 360 * Math.pow(2, zoom));
    const tileY = Math.floor((1 - Math.log(Math.tan(latitude * Math.PI / 180) + 1 / Math.cos(latitude * Math.PI / 180)) / Math.PI) / 2 * Math.pow(2, zoom));

    return {
        'x': tileX,
        'y': tileY,
        'zoom': zoom
    }
}